/**
 * Drag overlay component that shows while dragging a card.
 * Displays the card with enhanced visual feedback (shadow, scale, rotation).
 */

import type { PipelineDragOverlayProps } from '../types';

/**
 * Renders the dragged card with elevated visual treatment.
 * This creates the "lifted" feel during drag operations.
 */
export function PipelineDragOverlay({ children }: PipelineDragOverlayProps) {
  return (
    <div
      className='shadow-lg scale-[1.03] rotate-[2deg] opacity-95 pointer-events-none'
      style={{
        // Ensure it's above everything during drag
        zIndex: 1000,
      }}
    >
      {children}
    </div>
  );
}
